module.exports = __webpack_public_path__ + "static/media/icon-rappi.5d0485f6.png";